<template>
    <section class="modal modal-later" :class="{blur: open}">
        <div class="modal-wrap">
            <div class="modal-block" v-if="open">
                <div class="modal-block__close" @click="open = !open">
                    <img src="@/assets/images/icons/icon_close.svg">
                </div>
                <h3>{{ title }}</h3>
                <div class="modal-content" v-html="content"></div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'Modal',
    props: {
        title: {
            type: String,
            required: true
        },
        content: {
            type: [String, Array, Object],
            required: true
        }
    },
    data: () => {
        return {
            open: true
        }
    } 
}
</script>